import { useState } from "react";
import { Tooltip, IconButton, CircularProgress} from "@mui/material";

import axios from "../../../axios";

import AttachEmailRoundedIcon from '@mui/icons-material/AttachEmailRounded';

import useSnackbarStore from "../../../store/snackbar";

const EmailButton = ({ url, doc_type = "pdf", title = "Email PDF", email, disabled }) => {
  const [loading, setLoading] = useState(false);

  email = email || "moshekl101@gmail.com"; // for testing

  const showSnackbar = useSnackbarStore((state) => state.showSnackbar);

  let query = `?doc_type=${encodeURIComponent(doc_type)}&email=${encodeURIComponent(email)}`;

  const emailFile = async () => {
    if (!url || !email) return;
    setLoading(true);
    try {
      await axios.get(`${url}${query}`, {});
      showSnackbar("Email sent successfully", "success");
    } catch (e) {
      console.log(e);
      showSnackbar("Failed to send email", "error");
    } finally {
      setLoading(false);
    }
  }
  return (
    <Tooltip title={title}>
      <IconButton size="small" color="tertiary" onClick={emailFile} disabled={disabled}>
        {loading ? <CircularProgress size={20} /> : <AttachEmailRoundedIcon />}
      </IconButton>
    </Tooltip>
  )
};

export default EmailButton;